import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import { Employee } from '../employee/employee';
import { EboTenantItem } from './ebo-tenant-item';

export class EboTenantItemTo extends EboTenantItem {
  modifiedOn: Dayjs;
  modifiedById: string;
  modifiedBy: Employee;
  modifiedViaId: string;

  constructor(jsonData: Partial<EboTenantItemTo>) {
    super(jsonData);
    if (jsonData) {
      // ** Create complex objects
      if (jsonData.modifiedBy) this.modifiedBy = new Employee(jsonData.modifiedBy);
      if (jsonData.modifiedOn) this.modifiedOn = SDate.newUtc(jsonData.modifiedOn);
    }
  }
}
